export const API_URL = 'https://gedy.furbtech.com.br/api';
export const APP_VERSION = '1.0.0';
